import { render, staticRenderFns } from "./StatisticsRequisites.vue?vue&type=template&id=3b03ebc8&"
import script from "./StatisticsRequisites.vue?vue&type=script&lang=js&"
export * from "./StatisticsRequisites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports